import "./Header.scss";
import Menu from "./Menu";

const Header = () => {
    return (
        <div>
            <header className="header">
                <Menu></Menu>
            </header>
        </div>
    );
};

export default Header
